import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {
  Etape4_trackingEnum
}                                                   from "../../../../../shared/services/trackingService/button_tracking.enum";
import {
  TrackingService
}                                                   from "../../../../../shared/services/trackingService/tracking.service";

@Component({
             selector:        'app-selfcare-text-preco',
             templateUrl:     './selfcare-text-preco.component.html',
             styleUrls:       ['./selfcare-text-preco.component.scss'],
             changeDetection: ChangeDetectionStrategy.OnPush,
             standalone:      true,
             imports:         [],
             providers:       []
           })
export class SelfcareTextPrecoComponent implements OnInit {

  constructor(private _trackingService: TrackingService) {
  }

  ngOnInit(): void {
  }

  openSimulateur() {
    this._trackingService.trackButtonClick(Etape4_trackingEnum.VIGNETTE_EMPRUNTEUR);
    window.open('https://www.groupama.fr/assurance-emprunteur/simulateur', 'blank');
  }
}
